const state = {
  rawProductOptionTypes: [],
  productOptionsReviewsCountMap: {},
  isLoadingProductOptionTypes: true
};

const mutations = {
  SET_PRODUCT_OPTION_TYPES(state, rawProductOptionTypes) {
    state.rawProductOptionTypes = rawProductOptionTypes;
  },
  SET_IS_LOADING_PRODUCT_OPTION_TYPES(state, isLoadingProductOptionTypes) {
    state.isLoadingProductOptionTypes = isLoadingProductOptionTypes;
  },
  SET_PRODUCT_OPTION_REVIEWS_COUNT_MAP(state, productOptionsReviewsCountMap) {
    state.productOptionsReviewsCountMap = productOptionsReviewsCountMap;
  }
};

const actions = {
  fetchProductOptionTypes({ commit, rootState }, params) {
    const product_code = rootState.productCode;
    commit('SET_IS_LOADING_PRODUCT_OPTION_TYPES', true);
    rootState.api
      .fetchProductOptionTypes(product_code, params?.fields || '')
      .then(({ data }) => {
        commit('SET_PRODUCT_OPTION_TYPES', data.product_option_types);
        commit(
          'SET_PRODUCT_OPTION_REVIEWS_COUNT_MAP',
          data.product_option_reviews_count_map
        );
      })
      .finally(() => commit('SET_IS_LOADING_PRODUCT_OPTION_TYPES', false));
  }
};

export default { namespaced: true, state, mutations, actions };
